import { render, staticRenderFns } from "./ShortDescriptionSmallSize.vue?vue&type=template&id=4dd07387&"
import script from "./ShortDescriptionSmallSize.vue?vue&type=script&lang=js&"
export * from "./ShortDescriptionSmallSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports